/**
 * Phase 25 — an item's Tag Rules tags on its row (a text, a prompt group, a
 * gateway, a list): small chips in each tag's colour, the first three and
 * "+N" (the rest on hover). The panel gives the colours once (the preview's
 * `tagColors`), so every row reads them without threading props.
 * For Media Devoted | Created By Ciro Autiero
 */
import { createContext, type FC, type ReactNode, useContext } from 'react';

import { TagDot } from './tags';

const TagColors = createContext<Record<string, string> | undefined>(undefined);

export const TagColorsProvider: FC<{ colors?: Record<string, string>; children: ReactNode }> = ({ colors, children }) => (
  <TagColors.Provider value={colors}>{children}</TagColors.Provider>
);

export const TagChips: FC<{ tags?: string[]; max?: number }> = ({ tags, max = 3 }) => {
  const colors = useContext(TagColors);
  if (!tags || tags.length === 0) return null;
  const rest = tags.slice(max);
  return (
    <span className="inline-flex min-w-0 flex-wrap items-center gap-1" data-testid="tag-chips">
      {tags.slice(0, max).map((t) => (
        <span key={t} className="inline-flex items-center gap-1 rounded-full border border-border/70 bg-background px-1.5 text-[10px] leading-4 text-foreground/80">
          <TagDot color={colors?.[t]} className="h-2 w-2" />
          {t}
        </span>
      ))}
      {rest.length > 0 ? (
        <span className="text-[10px] text-muted-foreground" title={rest.join(', ')}>
          +{rest.length}
        </span>
      ) : null}
    </span>
  );
};
